import { useMemo } from "react";
import { Dispatch } from "@reduxjs/toolkit";
import { useDispatch, useSelector, useStore } from "react-redux";
import type { AppDispatch, RootState } from "../../features/app/Store";
import { selectApplicationSessionEpoch } from "../../features/app/store/applicationSessionStore";

/** Prevent an async component callback from dispatching into a later account. */
export function useSessionDispatch<TDispatch extends Dispatch = AppDispatch>(): TDispatch {
  const dispatch = useDispatch<AppDispatch>();
  const store = useStore<RootState>();
  const epoch = useSelector(selectApplicationSessionEpoch);
  return useMemo(
    () =>
      ((action: Parameters<AppDispatch>[0]) => {
        if (selectApplicationSessionEpoch(store.getState()) !== epoch) {
          if (typeof action === "function") {
            throw new DOMException("Authentication session changed", "AbortError");
          }
          return action;
        }
        return dispatch(action);
      }) as unknown as TDispatch,
    [dispatch, epoch, store]
  );
}
